import { SquareDrawer } from "./SquareDrawer";
export async function loadSquareShape(engine, refresh = true) {
    await engine.addShape(["edge", "square"], new SquareDrawer(), refresh);
}
